import { Component, Injectable, OnInit, forwardRef } from "@angular/core";
import { NavController, NavParams, ModalController, IonicModule } from "@ionic/angular";
import { EscalaPessoaFuncaoPage } from "../escala-pessoa-funcao/escala-pessoa-funcao.page";
import { EscalaProvider } from "src/app/services/escala/escala";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-escala-pessoa",
  templateUrl: "./escala-pessoa.page.html",
  styleUrls: ["./escala-pessoa.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class EscalaPessoaPage implements OnInit {
  titulo: string = "";
  cc: number = 0;
  filtro: string;
  filtroBusca: string = "a";
  idFuncao: any = "";
  pagination: any = { currentPage: 0, pageCount: 0 };
  pessoaList: any = [];
  isVisitante: boolean = false;
  showTipo: boolean = false;
  arrayPessoa: any = [];
  grupo: any = null;
  entidade: any = "";
  idEntidade: any = "";
  idEscala: any = "";
  isEnsino: any = {};
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public escalaProvider: EscalaProvider,
    public modalCtrl: ModalController
  ) {
    this.showTipo = this.navParams.get("showTipo");
    this.grupo = this.navParams.get("grupo");
    this.entidade = this.navParams.get("entidade");
    this.idEscala = this.navParams.get("idEscala");
    this.idEntidade = this.navParams.get("idEntidade");
    this.isEnsino = this.navParams.get("isEnsino");
    this.idFuncao = this.navParams.get("idFuncao") || "";
  }

  ngOnInit() {
    this.loadPessoas(null);
    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  loadPessoas(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;

    if (!infiniteScroll) {
      this.pagination = { currentPage: 1, pageCount: 10 };
      this.arrayPessoa = [];
      this.pessoaList = [];
    }

    this.escalaProvider
      .getPessoas(this.filtroBusca, this.grupo, this.entidade, this.idEntidade, this.idFuncao, this.pagination)
      .subscribe((res) => {
        if (!infiniteScroll) {
          this.arrayPessoa = [];
          this.pessoaList = [];
        }

        this.pessoaList = this.pessoaList.concat(res.pessoas);
        this.pagination = res.pagination;

        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  validaPage() {
    if (Number(this.pagination.currentPage) <= Number(this.pagination.pageCount)) {
      return true;
    }

    return false;
  }

  async selecionar(p: any) {
    if (this.arrayPessoa.length) {
      this.selecionarPessoa(p);
    } else {
      let pessoa = [];
      pessoa.push(p);
      let data = {
        entidade: this.entidade,
        idEntidade: this.idEntidade,
        pessoa: pessoa,
        idEscala: this.idEscala,
      };
      const modalPage = await this.modalCtrl.create({
        component: EscalaPessoaFuncaoPage,
        componentProps: data,
      });
      modalPage.present();

      (await modalPage.onDidDismiss()).data;
      if (data) {
        this.loadPessoas(null);
      }
    }
  }

  async funcaoGeral() {
    const data = {
      entidade: this.entidade,
      idEntidade: this.idEntidade,
      pessoa: this.arrayPessoa,
      idEscala: this.idEscala,
    };
    const modalPage = await this.modalCtrl.create({
      component: EscalaPessoaFuncaoPage,
      componentProps: data,
    });

    modalPage.onWillDismiss().then(async (data) => {
      if (data) {
        this.loadPessoas(null);
      }
    });

    modalPage.present();
  }

  onCancel() {
    this.pessoaList = [];
    this.pagination = { currentPage: 0, pageCount: 0 };
    this.loadPessoas(null);
  }

  onInput() {
    this.filtroBusca = this.filtro;
    if (this.filtro == "") {
      this.filtroBusca = "a";
    }
    this.loadPessoas(null);
  }

  selecionarPessoa(pessoa: { selecionado: boolean; id: any }) {
    if (pessoa.selecionado) {
      this.arrayPessoa.splice(
        this.arrayPessoa
          .map(function (e: { id: any }) {
            return e.id;
          })
          .indexOf(pessoa.id),
        1
      );
    } else {
      this.arrayPessoa.push(pessoa);
    }

    pessoa.selecionado = !pessoa.selecionado ? true : false;
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
